import React, { useContext, useState, useEffect, memo } from 'react';
import { Modal, Button, Dropdown } from 'react-bootstrap';
import { acceptTnc, workingHours } from './indexApi';
import { isMobile } from '../../utils/utils';
import { Context as AuthContext } from '../../Redux/context/AuthContext';
import { useHistory, useLocation } from 'react-router-dom';
import styles from './style.module.scss';
import { IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { useSelector } from 'react-redux';
import getApobSupplierId from '../../utils/getApobSupplierId';

const TermsAndConditionPage = ({
  disableButtons = false,
  showTerms,
  showWorkingHours,
  showClose,
  agreementOpen,
  closeAgreementOpen,
  isTnC,
  tier,
  toggleNav,
}) => {
  const { logout, updateTnc, updateWorkingHrs } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(showTerms);
  const [showWorkingHourss, setShowWorkingHours] = useState(showTerms ? false : showWorkingHours);
  const [businessDay, setBusinessDay] = useState();
  const [tncChecked, setTncChecked] = useState(false);
  const { tierDetails } = useSelector((state) => state.user);
  const { apobSupplierID } = getApobSupplierId();

  let history = useHistory();
  let location = useLocation();

  const handleClose = async () => {
    setShowModal(false);
    await logout();
    window.location.reload();
  };

  useEffect(() => {
    if (agreementOpen) {
      setShowModal(true);
    }
  }, [agreementOpen]);

  //function to search vendor name
  const acceptTerms = async () => {
    const data = { platform: 'FALCON', supplierId: apobSupplierID };
    const response = await acceptTnc(data);
    if (response && response.data && response.data.status === 'success') {
      await updateTnc();
      setShowModal(false);
      setShowWorkingHours(true);
    }
  };

  //function to accept working hours
  const acceptWorkingHours = async () => {
    let { from } = location.state || { from: { pathname: '/' } };
    let hrs;
    BusinessDay.map((item) => {
      if (item.name === businessDay) {
        hrs = item.value;
      }
    });
    const data = { non_working: hrs, supplierId: apobSupplierID };
    const response = await workingHours(data);
    if (response && response.data && response.data.status === 'success') {
      await updateWorkingHrs();
      setShowWorkingHours(false);
      history.replace(from);
    }
  };

  const getCancellationCount = () => {
    // if (
    //   tierDetails &&
    //   tierDetails?.tier &&
    //   ['SILVER', 'BRONZE'].includes(tierDetails?.tier.toUpperCase())
    // )
    //   return '4';
    // else if (
    //   tierDetails &&
    //   tierDetails?.tier &&
    //   ['PLATINUM', 'GOLD'].includes(tierDetails?.tier.toUpperCase())
    // )
    //   return '7';
    // else return '';
    return '1';
  };

  const tncObj = [
    {
      heading: 'Shipping Charges',
      content:
        'The shipping charges shall be charged at the rate of 0.5 % of the invoice value and shall be deducted at the time of payment of corresponding invoices.',
    },
    {
      heading: 'RTV',
      content:
        'The Products can be returned to the Supplier within Forty Five (45) days from the date of pick-up. In case the Product has been returned due to any reason, and the payment was already made to the supplier, then the payment corresponding to the returns shall be adjusted in future payments of any invoice.',
    },
    {
      heading: 'Cancellation Charges',
      content:
        `In case of more than ${getCancellationCount()} cancellations/expiry/rejections in a calendar month by the supplier, a penalty of ₹250 or 1% of order value(whichever is higher) per order(for all the breached orders) at the discretion of Sterne India shall be imposed on the seller. Accrued cancellation charges shall be adjusted in future payments.` +
        ` Cancellation/Expiry charges shall be calculated at the end of each month and shall be deducted in
      the first payment cycle of the next month.`,
    },
  ];

  return (
    <div style={{ height: '500px' }}>
      <Modal
        show={showModal}
        onHide={handleClose}
        size="lg"
        centered
        backdrop="static"
        className="h-300"
        style={{
          background: 'rgba(2, 2, 2, 0.7)',
        }}
      >
        <Modal.Header>
          <Modal.Title style={{ fontSize: '1rem', fontWeight: '600' }}>
            {isTnC ? 'Terms and Conditions' : 'Seller Agreement'}
          </Modal.Title>
          <div className="d-flex justify-content-end">
            {showClose && (
              <IconButton
                className="p-0"
                onClick={() => {
                  setShowModal(false);
                  closeAgreementOpen(false);
                  toggleNav && toggleNav(true);
                }}
                style={{ border: 'none', outline: 'none' }}
              >
                <CancelIcon style={{ color: '#ccc', fontSize: '35px' }} />
              </IconButton>
            )}
          </div>
        </Modal.Header>
        <Modal.Body
          style={
            !isMobile()
              ? {
                  fontSize: '0.9rem',
                  height: isTnC ? 'calc(100vh - 400px)' : 'calc(100vh - 300px)',
                  overflow: 'auto',
                }
              : { fontSize: '0.9rem', overflow: 'auto' }
          }
        >
          <div className="d-flex justify-content-between align-items-center">
            <div style={isMobile() ? { height: '60px' } : { height: '70px' }}>
              <img
                alt="arzooo-header-logo"
                src="https://static.arzoopro.com/images/falcon-logo.png"
                max-width="100%"
                height="100%"
              ></img>
            </div>
            <div style={isMobile() ? { height: '20px' } : { height: '30px' }}>
              <img
                alt="arzooo-header-logo"
                className="headerLogo"
                src="https://static.arzoopro.com/images/f+logo-01.png"
                max-width="100%"
                height="100%"
              ></img>
            </div>
          </div>
          {isTnC && (
            <div
              className="ml-5"
              style={{ textAlignLast: 'left', marginTop: '20px', marginRight: '5px' }}
            >
              <div style={{ paddingBottom: '20px' }}>
                <span style={{ fontWeight: '500' }}>Updated On: </span>
                <span>08-11-2024</span>
              </div>
              {tncObj.map((item, index) => {
                return (
                  <ol start={index + 1}>
                    <li dir="ltr">
                      <p dir="ltr">
                        <strong>{item.heading}</strong>
                        <span>
                          <strong>:</strong> {item.content}
                        </span>
                      </p>
                    </li>
                  </ol>
                );
              })}
            </div>
          )}

          {!isTnC && (
            <div
              className="ml-5"
              style={{ textAlignLast: 'left', marginTop: '2px', marginRight: '5px' }}
            >
              <p dir="ltr">
                <span style={{ textDecoration: 'underline', marginLeft: '-10px' }}>
                  <strong>Terms and Conditions</strong>
                </span>
              </p>
              <p dir="ltr" style={{ marginLeft: '-10px' }}>
                <span>The Seller declares that:</span>
              </p>
              <ol>
                <li dir="ltr">
                  <p dir="ltr">
                    <span>
                      By clicking the Submit button below, Seller (or its authorized representative)
                      hereby agrees and acknowledges that,&nbsp;
                    </span>
                  </p>
                </li>
              </ol>
              <p dir="ltr">
                <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;a. </span>{' '}
                <span>I can understand, read, and write in the English language,</span>
              </p>
              <p dir="ltr">
                <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;b. </span>{' '}
                <span>
                  I have read and understood the terms and conditions contained below
                  (&ldquo;Terms&rdquo;).
                </span>
              </p>
              <p dir="ltr">
                <span>I, the &ldquo;</span>
                <span>Seller</span>
                <span style={{ textAlignLast: 'justify' }}>
                  &rdquo;, who is in the business of
                  manufacturing/Distributing/wholesaling/Retailing consumer electronics goods is
                  willing to register itself and list my product catalogues on E-commerce Technology
                  platform owned and managed by Moksha Retails Global Pvt Ltd wherein against the
                  demand generated on the online portal from the buyers. Moksha Retails Global
                  Private Limited intend to procure the goods for their onward sales to the intended
                  buyers. &nbsp;
                </span>
              </p>
              {/* <p dir="ltr">
                <span>
                  Whereas the Sterne India Pvt Ltd is in the business of developing, maintaining and
                  operating software and Technology to enable Business to Business sales between
                  manufacturer, Distributor, wholesaler, retailer and other businesses by way of
                  purchasing of the goods by Sterne India Private Limited for their onward sales to
                  the intended businesses.
                </span>
              </p> */}
              <ol start="2">
                <li dir="ltr">
                  <p dir="ltr">
                    <span>
                      Whereas Moksha Retails Global Pvt Ltd is in the business of developing,
                      maintaining and operating software and Technology to enable Business to
                      Business sales between manufacturer, Distributor, wholesaler, retailer and
                      other businesses by way of purchasing of the goods by Moksha India Private
                      Limited for their onward sales to the intended businesses.
                    </span>
                    {/* <span>Sterne</span> */}
                    {/* <span>&rdquo;).</span> */}
                  </p>
                </li>
              </ol>
              {/* <p>
                <span>
                  <span>&nbsp;</span>
                </span>
              </p> */}
              <ol start="3">
                <li dir="ltr">
                  <p dir="ltr">
                    {/* <strong>Maintaining required inventory</strong> */}
                    <span>
                      The Seller agrees that the Seller’s action of entering the details and
                      clicking the “Submit” button, constitutes a valid acceptance of the Terms
                      contained herein and creates a binding and enforceable agreement between the
                      Seller and Moksha Retails Global Private Limited (“Moksha”).
                    </span>
                  </p>
                </li>
              </ol>
              <p>
                <span>
                  <span>&nbsp;</span>
                </span>
              </p>
              <ol start="4">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>Maintaining required inventory: </strong>
                    <span>
                      Seller shall be responsible for ensuring that the Seller Panel is updated and
                      reflects the real-time availability / non-availability of the Products listed
                      on the Platform. Seller shall be
                    </span>
                  </p>
                  <p dir="ltr">
                    <span>
                      required to retain an adequate inventory of the Products listed on the
                      Platform, for successful fulfillment of Orders.
                    </span>
                  </p>
                </li>
              </ol>
              <p>
                <span>
                  <span>&nbsp;</span>
                </span>
              </p>
              <ol start="5">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>Invoicing and GST Compliance:&nbsp;</strong>
                    <span>
                      : Issuing correct and complete Invoice is the sole and primary responsibility
                      of the Seller. Seller shall issue an Invoice in the name of Moksha, which
                      Invoice shall be uploaded on the Falcon Panel. The Seller shall ensure that
                      the Invoices raised by the Seller shall be in compliance with the Goods and
                      Service Tax Law and other applicable laws. Seller shall be responsible to
                      update the Seller Panel to reflect this development. Seller shall maintain
                      details of all Invoices as per applicable tax laws and shall be solely
                      responsible to maintain proper records of such Invoices including but not
                      limited to maintenance of books of accounts in respect of the Transactions
                      through the Platform. However, Moksha at its discretion may facilitate
                      technology tools either of its own or procured from / integrated through third
                      party(ies) network /technology for generation of such invoices / E-invoices
                      and it is agreed that Seller shall use such tools and authorise Moksha to
                      enable such technologies and provide relevant information that are required to
                      that effect. Seller shall also provide access to such documents and invoices
                      as and when demanded by Moksha. &nbsp;
                    </span>
                  </p>
                  <p dir="ltr">
                    <span>
                      Apart from that, Invoices shall contain IMEI / Serial Numbers of the products
                      as stipulated under different legislations by considering the national
                      security and integrity.
                    </span>
                  </p>
                </li>
              </ol>
              <ol start="6">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>SLA Adherence and Penalties:</strong>
                  </p>
                </li>
              </ol>
              <div
                className="ml-5"
                style={{ textAlignLast: 'left', marginTop: '2px', marginRight: '5px' }}
              >
                <ol type="a">
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        Seller shall ensure that all the Product are dispatched within the Shipment
                        SLA, along with all other required information, manuals, accessories (where
                        applicable) warranty documents (where applicable) and any other relevant
                        documents supplied by the Brand for the Product.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        There may be certain orders that Seller is unable to accept and has the
                        right to cancel by rejecting the order on the Seller Panel directly. Seller
                        reserves the right to refuse or cancel any order in situations such as
                        without limitation, non-availability of the Product or quantities ordered by
                        Buyer or inaccuracies or errors in pricing information. However, for the
                        order cancelled by the seller, Moksha reserves the right to impose penalty.
                        Penalty Charges shall be displayed from time to time on the Panel /
                        Dashboard as per the rates applicable. Moksha also is entitled to impose
                        penalties as communicated periodically from an official representative of
                        Moksha via email, for poor performance including but not limited to Order
                        Expiry, Seller Order Rejection / Cancellation, Partial handover, delay in
                        handover beyond stipulated SLA. Seller will not challenge the levy of
                        penalty amount.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        Notwithstanding the imposition of penalties and other actions, Moksha
                        reserves its right to not to deal with the Seller and delist from Vendor’s
                        List in case of any breach in deliverables, breach of agreement and
                        non-fulfillment of the obligations by the Seller. Seller is not entitled to
                        claim any direct or indirect damages/ compensation etc. which results due to
                        its delisting.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        Seller has to take immediate action and remove Products offered for sale in
                        case past orders of such Products are not fulfilled due to reasons
                        attributable to the Seller.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        Seller shall ensure that all the products listed on the panel comply with
                        the Legal Metrology Act, 2009 and Rules framed thereunder and Moksha shall
                        not be held liable for any non-compliance by the Seller.
                      </span>
                    </p>
                  </li>
                </ol>
              </div>
              <p>
                <span>
                  <span>&nbsp;</span>
                </span>
              </p>
              <ol start="7">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>Agreement for RTV</strong>
                    <span>
                      : The Seller agrees to take back Products in case of request by Moksha
                      including but not limited to in case of including QC Fail, defects or
                      non-salability of the products. Where the Product has been returned to the
                      Seller, Moksha shall have right to adjust future payments against these
                      returns. &nbsp;
                    </span>
                  </p>
                </li>
              </ol>
              <p>
                <span>
                  <span>&nbsp;</span>
                </span>
              </p>
              <ol start="8">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>Flite Model: </strong>
                    <span>
                      To facilitate the speedy availability of the goods to Moksha India and fast
                      track the transaction, Seller agrees to work on Just-in-Time Model by opening
                      his own facilities at the nearby locations of Moksha India as agreed between
                      the Seller and Stern India from time to time. In case Moksha India is
                      operating in a premises wherein, the seller intends to operate with an
                      additional place of business, Moksha India at its discretion may provide an
                      NoC and other relevant documents and the Seller shall register the premises
                      with relevant statutory authorities and undertake the complete responsibility
                      of fulfilling relevant statutory obligations that are required in this regard.
                      Seller undertakes to adhere to the terms and conditions of Flite fulfilment
                      model which shall be communicated from time to time to Seller. &nbsp;
                    </span>
                  </p>
                </li>
              </ol>
              <p>
                <span>
                  <span>&nbsp;</span>
                </span>
              </p>
              <ol start="9">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>Payment policy </strong>
                    <span>
                      <strong>:</strong> Payments will be made against accurate invoices post
                      product pickup and QC check to the satisfaction of Moksha team. For the
                      transportation of goods sold by the Seller, Shipping charges shall be charged
                      on the order value which will be communicated from time to time if applicable.
                    </span>
                  </p>
                </li>
              </ol>
              <p>
                <span>
                  <span>&nbsp;</span>
                </span>
              </p>
              <ol start="10">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>Confidentiality </strong>
                    <span>
                      <strong>:</strong> Seller will be responsible for maintaining the
                      confidentiality of the Falcon Panel and the information provided therein, and
                      shall be fully responsible for maintaining confidentiality of all activities
                      that occur under Seller’s Falcon Panel. Seller shall neither disclose nor part
                      with the Seller Page credentials to anyone including any third party
                      aggregators for the purpose of managing Seller’s inventory and fulfilling
                      Seller Orders. Furthermore, the Seller shall not disclose details of business
                      turnover, etc to any third party.&nbsp;
                    </span>
                  </p>
                </li>
              </ol>
              <ol start="11">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>Previous Liability: </strong>
                    <span>
                      <strong>:</strong> The seller agrees that there is no previous outstanding
                      payment on any transactions done in the Falcon Panel prior to this. Moksha
                      shall not be responsible for any previous outstanding payment or any liability
                      whatsoever that may have arisen before signing this T&C with Moksha. &nbsp;
                    </span>
                  </p>
                </li>
              </ol>
              <ol start="12">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>Obligations of the Seller on Malpractice&nbsp;</strong>
                    <span>
                      : Seller confirms and understands that selling and delivering wrong, fake,
                      duplicate, spurious, counterfeit, damaged, defective, refurbished,
                      non-compliant or previously owned Products will cause great prejudice and harm
                      to the reputation and goodwill of Moksha and may also cause harm and prejudice
                      to the end-Buyers. Seller acknowledges and warrants that Seller shall not sell
                      any Product which may cause prejudice or harm to the reputation and goodwill
                      of Moksha. &nbsp;
                    </span>
                  </p>
                  <p dir="ltr">
                    <span>
                      Moksha reserves the right to determine the Sellers and the products from whom
                      Moksha shall buy. Moksha also reserves the right to suspend access to
                      registered Sellers to the Falcon Panel, or to terminate such access granted
                      under this Agreement, without assigning any reasons thereto.
                    </span>
                  </p>
                  <p dir="ltr">
                    <span>
                      Seller declare that all the particulars and information provided are true,
                      correct, complete and up to-date in all respects and that the Seller has not
                      withheld any information whatsoever.
                    </span>
                  </p>
                  <p dir="ltr">
                    <span>
                      The Seller confirms that as a manufacturer / distributor/ wholeseller /
                      retailer he is authorized to sell the Products that are listed in the Catalog
                      by the Seller, and that the Seller assumes all responsibility for this
                      representation.
                    </span>
                  </p>
                  <p dir="ltr">
                    <span>
                      Seller undertakes and confirms that it deals only in original, legitimate, and
                      genuine Products and in which it owns rights, which are either
                      self-manufactured and/or procured from legitimate channels and in compliance
                      with all the legal requirements. Seller further undertakes that it shall not
                      sell fake/spurious/non authentic products on the Platform. In case the product
                      is found to be fake, duplicate, spurious, counterfeit, damaged, refurbished,
                      the Seller shall refund the entire amount of PO value to Moksha, within 24
                      hours of demand from Moksha.
                    </span>
                  </p>
                </li>
              </ol>
              <ol start="13">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>KYC and Documentation :</strong>
                  </p>
                </li>
              </ol>
              {/* <p dir="ltr">
                <span>
                  Seller agrees to the below terms and conditions, in case the Seller avails the
                  Credit Facility
                </span>
              </p> */}
              <div
                className="ml-5"
                style={{ textAlignLast: 'left', marginTop: '2px', marginRight: '5px' }}
              >
                <ol type="a">
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        I authorize Moksha to exchange, share all information, documents , KYC and
                        details as provided by me and in relation to my existing loans and/or
                        repayment history to any third party including but not limited to its group
                        companies, service providers, banks, financial institutions, credit bureaus,
                        telecommunication companies, statutory bodies, business partners etc. for
                        customer verification, personalization of products or services, credit
                        rating, data enrichment, marketing or promotion of Moksha services or
                        related products or that of its associates/business partners and affiliates
                        or for enforcement of your obligations and I shall not hold Moksha (or any
                        of its group companies or its/their agents/representatives/ business
                        partners) liable for the use/sharing of the information as stated above. I
                        have no objection in sharing my credentials to authorized third parties of
                        Moksha.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        I agree and affirm that Moksha may contact me and communicate with me over
                        telephonic calls, or SMS on the mobile number provided, or through any other
                        communication mode (“Communication Modes”) to verify the details provided by
                        me. Further, I confirm that I would like to know through the above-mentioned
                        Communication Modes various Moksha credit offer schemes or loan promotional
                        schemes or any other promotional schemes relating to various
                        products/services offered by Moksha/its group companies/business partners
                        from time to time and hereby authorize Moksha, its group companies,
                        employees, agents, associates, business partners to contact me from time to
                        time for the same.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        I hereby expressly consent and authorise Moksha / its
                        representatives/agents/ its business partners/its group companies/affiliates
                        to send me any communication regarding products/services offered by them
                        using various communication channels, such as, telephone,
                        calls/SMS/bitly/bots/emails/post etc.
                      </span>
                    </p>
                  </li>
                </ol>
              </div>
              <ol start="14">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>Representation and Warranties:</strong>
                  </p>
                </li>
              </ol>
              <div
                className="ml-5"
                style={{ textAlignLast: 'left', marginTop: '2px', marginRight: '5px' }}
              >
                <ol type="a">
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        Seller represents and warrants that the Seller is the registered
                        owner/licensed user of the brand/trademark in the Product and has valid
                        authority from the actual owner to list and sells its products on this
                        platform and further, agree and undertake to permit Moksha to use the brand,
                        logo, trademark and tradename of the Product for marketing and promotional
                        purposes.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        Seller confirms that the Seller has/had no insolvency proceedings against it
                        nor have the Seller ever been adjudicated insolvent by any court or other
                        authority and further confirm that the Seller has read the information on
                        credits made available by Moksha.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        Seller undertakes to keep Moksha updated of any change in the information
                        provided within 30 days from the date of change. In case of any change in my
                        business address or nature of business or business ownership or contact
                        information like mobile number, email id etc, it is the Seller’s
                        responsibility to inform Moksha on such changes within 30days from the date
                        of change. Moksha can file a legal suit against the Seller if it fails to
                        inform the same.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        Seller will comply with all taxation, statutory and regulatory compliance
                        and Moksha shall not be held liable for any non compliance by Seller.
                        However, In case any liability comes on Moksha because of Seller's
                        non-compliance or Moksha has to incur any losses because of Seller, Seller
                        will compensate the same entirely.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        Moksha and each of Moksha entities officers, directors, contractors,
                        associated parent company, agents shall not be responsible for the
                        authenticity of the Information that the Seller provides to Moksha. Seller
                        shall indemnify and hold harmless Moksha and each of Moksha entities
                        officers, directors, contracts or agents and any third party relying on the
                        Information provided by the Seller. Seller also agrees to indemnify Moksha
                        and/or its officers, directors, and employees from any claims, liabilities,
                        damages, and expenses arising out of Seller's breach of this Agreement,
                        negligence, infringement of intellectual property rights, violation of laws,
                        or disputes with third parties related to the Agreement. Seller's
                        indemnification shall extend to all costs incurred by Moksha, including
                        legal fees, and shall survive the termination of this Agreement.
                      </span>
                    </p>
                  </li>
                </ol>
              </div>
              <ol start="15">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>Credit Facility </strong>
                    <span>
                      <strong>:</strong> Seller agrees to the below terms and conditions, in case
                      the Seller avails the Credit Facility: &nbsp;
                    </span>
                  </p>
                </li>
              </ol>
              <div
                className="ml-5"
                style={{ textAlignLast: 'left', marginTop: '2px', marginRight: '5px' }}
              >
                <ol type="a">
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        Seller understands and acknowledges that Lender(s) shall have the absolute
                        discretion and Lendor(s) may reject application of the seller without
                        assigning any reason and that Moksha shall not be responsible/liable in any
                        manner whatsoever for such rejection.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        Seller further understands and agree that pursuant to the application form,
                        Seller shall be required to submit documents to the satisfaction of the
                        Lendor and accept the credit terms and conditions for availing the credit
                        granted to me.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        Moksha and/or Lender(s) independently and/or jointly shall have rights to
                        take legal action for any non- payment of dues or default.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        I hereby expressly consent and authorise Moksha / its representatives/
                        agents/ its business partners/ its group companies/ affiliates to initiate
                        checks and verify data relating to my PAN, Aadhaar, GST, Bank transactions,
                        other related documents and process my credit application.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        I have authenticated the registration process through OTP from my registered
                        mobile number with Moksha which is provided by me at the time of
                        registration with Moksha.
                      </span>
                    </p>
                  </li>
                  <li dir="ltr">
                    <p dir="ltr">
                      <span>
                        In case if any liability comes on Moksha in view of the any actions /
                        inactions by the seller, Seller agrees that it is his sole resposibility and
                        shall compensate Moksha entirely.
                      </span>
                    </p>
                  </li>
                </ol>
              </div>
              <ol start="16">
                <li dir="ltr">
                  <p dir="ltr">
                    <strong>Dispute Resolution </strong>
                    <span>
                      <strong>:</strong> This Agreement and any disputes arising hereunder shall be
                      determined in accordance with the laws of India. If any dispute arises between
                      the Parties hereto during the subsistence of this Agreement or thereafter, in
                      connection with, or arising out of, this Agreement, the courts of Bangalore
                      shall have exclusive jurisdiction in connection with this Agreement &nbsp;
                    </span>
                  </p>
                </li>
              </ol>
              <p>
                <span>
                  <span>&nbsp;</span>
                </span>
              </p>
              <p style={{ marginLeft: '-15px' }}>
                <span>
                  Arzooo is the brand name of Moksha Retails Global Private Limited (“Moksha”),
                  effective as of November 8, 2024. Moksha expressly disclaims any liability,
                  obligation, or responsibility of any nature, whether contractual, statutory,
                  tortious, or otherwise, towards the seller(s) for any acts, omissions,
                  obligations, claims, disputes, or liabilities arising from or relating to Arzooo
                  prior to this date. Any and all such pre-existing liabilities, including but not
                  limited to financial, contractual, operational, or legal obligations, shall remain
                  solely with the original entity/entities or persons with whom such liabilities
                  were incurred and shall under no circumstances transfer to or be enforceable
                  against Moksha. This disclaimer of liability shall apply irrespective of any
                  transition, rebranding, or association between Arzooo and Moksha and shall be
                  binding on all the sellers.
                </span>
              </p>
              <p>
                <span>
                  <span>&nbsp;</span>
                </span>
              </p>
              {/* <p dir="ltr">
                <strong>Annexure A: Penalty Charges</strong>
              </p>
              <p dir="ltr">
                <span>
                  1. In case of repeat cancellations arising due to issues related to the Seller, a
                  cancellation charge of up to INR 250 per unit will have to be borne by the Seller.
                </span>
              </p>
              <p dir="ltr">
                <span>
                  2. In case of order not accepted within the expiry limit of 24 hours or rejected,
                  a penalty of INR 50 per order will be borne by the Seller.
                </span>
              </p> */}
            </div>
          )}
          {!disableButtons && (
            <div style={{ marginLeft: '20px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tncChecked}
                    onChange={(e) => setTncChecked(e.target.checked)}
                    color="primary"
                    size="small"
                  />
                }
                label="I agree to the Terms & Conditions"
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={() => handleClose()}>
            Decline
          </Button> */}
          {!disableButtons && (
            <Button
              style={{ background: '#22C0E7', border: 'none' }}
              onClick={() => acceptTerms()}
              disabled={!tncChecked}
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal show={showWorkingHourss} onHide={handleClose} size="lg" centered backdrop="static">
        <Modal.Header>
          <Modal.Title style={{ fontSize: '1rem', fontWeight: '600' }}>
            Setup Business Hours
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: '0.9rem' }}>
          <h6 className="mt-2 mb-3">Choose non-working days of your business:</h6>
          <form className={styles.formDiv}>
            <div className="row ml-2">
              {BusinessDay.map((item, index) => {
                return (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <label className={styles.labelComp} onClick={() => setBusinessDay(item.name)}>
                      <input type="radio" name="radio" />
                      <span>{item.name}</span>
                    </label>
                  </div>
                );
              })}
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className={`${businessDay ? styles.btn : styles.disableComp}`}
            onClick={() => (businessDay ? acceptWorkingHours() : null)}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default memo(TermsAndConditionPage);

const BusinessDay = [
  { name: 'Sunday', value: 6 },
  { name: 'Monday', value: 0 },
  { name: 'Tuesday', value: 1 },
  { name: 'Wednesday', value: 2 },
  { name: 'Thursday', value: 3 },
  { name: 'Friday', value: 4 },
  { name: 'Saturday', value: 5 },
];
